/** @format */

import {styled} from '@mui/material/styles';
import {Link, Typography} from '@mui/material';

export const CampaignLink = styled(Link)(({theme}) => ({
  cursor: 'pointer',
  color: `${theme.palette.semantic_dark?.primary?.main} !important`,
  overflow: 'hidden',

  '&.MuiTypography-root': {
    textDecoration: 'underline !important',
  },

  '&:hover': {
    color: `${theme.palette.semantic_dark?.primary?.hover} !important`,
  },
}));

export const CampaignName = styled(Typography)(() => ({
  overflow: 'hidden',
}));
